// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"RegionsList_tableContainer__3gLE_","cardTitle":"RegionsList_cardTitle__RG5Ym"};